import { render } from "./Prontos.vue?vue&type=template&id=b3ced240&scoped=true"
import script from "./Prontos.vue?vue&type=script&lang=js"
export * from "./Prontos.vue?vue&type=script&lang=js"

import "./Prontos.vue?vue&type=style&index=0&id=b3ced240&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3ced240"]])

export default __exports__